<template>
<div>
  <h4 v-if="cust.Role !== 'Admin' || !authenticated">
      You are not Authorised <a @click="auth.login()">Log In</a> to continue.
  </h4>
  <div v-if="cust.Role === 'Admin' && authenticated" id="customer">
      <p>Logged in as: {{cust.Acc}} </p>
      <br>
    <h4>Add Customer:</h4>
    <br>
      <label for="addCustomerAcc">Account No.</label>
   <b-input type="text" v-model="addCustomerAcc" name="addCustomerInput" placeholder="Customer Account No."></b-input>
   <p class="error" v-if="fieldErrorAcc">Account Already Exists!</p>
   <span v-if="addCustomerAcc">
     <br>
      <label for="addCustomerName">Customer Name</label>
   <b-input type="text" v-model="addCustomerName" name="addCustomerName" placeholder="Customer Name"></b-input>
   <p class="error" v-if="fieldErrorName">Too Short!</p>
   <br>
     <label for="addCustomerAuth0Id">Auth0 ID No.</label>
  <b-input type="text" v-model="addCustomerAuth0Id" name="addCustomerAuth0Id" placeholder="Remove the auth0| Should be 24 Characters"></b-input>
  <p class="error" v-if="fieldErrorAuth0Id">Should be 24 characters long!</p>
  <br>
  <label for="addCustomerType"  >Customer Type</label>
        <select name="TYPE" id="Type" class="form-control custom-select" v-model="addCustomerType">
          <option value="UK">UK - All Collections</option>
          <option value="EU">EU - All EU Collections</option>
          <option value="Export">Export - All Export Collections</option>
          <option value="Restricted">Restricted - Choose Which Collections to Allow</option>
        </select>
    <b-button class="btn btn-primary btn-margin" @click="addCustValidate(addCustomerAcc, addCustomerName, addCustomerAuth0Id, addCustomerType)">Add New Customer</b-button>
   </span>

    <br>
    <hr>
    <hr>
    <br>
    <h4>Edit Customer</h4>
      <br>

      <select class="form-control custom-select" v-model="selected" v-on:change="getCustomerDetail(selected)">
          <option disabled value="">Please select a Customer</option>
          <option v-for="customer in customerSorted" :key=customer._id :value="customer.Acc">{{customer.Acc}}</option>
      </select>
      <br>
      <div v-if="customerDetail.length === 0"><p></p></div>
      <div v-if="customerDetail.length != 0">
      <customerDetail  :customerDetail="customerDetail"/>
      </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import customerDetail from './CustomerDetail'

export default {
  name: 'customer',
  computed: {
    ...mapGetters([
      'customers',
      'customerDetail',
      'collectionsLive'
    ]),
    customerSorted () {
      return this.customers.slice(0).sort((a, b) => {
        let x = a.Name.toLowerCase()
        let y = b.Name.toLowerCase()
        if (x < y) { return -1 }
        if (x > y) { return 1 }
      })
    }
  },
  data () {
    return {
      selected: '',
      addCustomerAcc: '',
      addCustomerName: '',
      addCustomerAuth0Id: '',
      addCustomerType: 'UK',
      fieldErrorAcc: false,
      fieldErrorName: false,
      fieldErrorAuth0Id: false
    }
  },
  created () {
    // on view creation run actions getCustomers and getCollections and adds them to the store
    this.$store.dispatch('getCustomers')
    this.$store.dispatch('getCollectionsLive')
  },
  methods: {
    ...mapActions([
      'getCustomerDetail',
      'getCollectionsLive'
    ]),
    addCustValidate (Acc, Name, Auth0Id, Type) {
      this.fieldErrorAcc = false
      this.fieldErrorName = false
      this.fieldErrorAuth0Id = false
      let newCust = []
      newCust.Acc = Acc.toUpperCase()
      newCust.Name = Name
      newCust.Auth0Id = Auth0Id
      newCust.Type = Type
      let capAcc = newCust.Acc
      let custs = this.customers.find(cust => cust.Acc.toUpperCase() === capAcc)
      if (!custs) {
        if (Auth0Id.length === 24) {
          if (Name.length > 2) {
            this.$store.dispatch('addCustomer', newCust)
              .then((response) => {
                this.$store.dispatch('getCustomers')
                this.addCustomerAcc = ''
                this.addCustomerName = ''
                this.addCustomerAuth0Id = ''
                this.addCustomerType = 'UK'
              })
          } else {
            this.fieldErrorName = true
          }
        } else {
          this.fieldErrorAuth0Id = true
        }
      } else {
        this.fieldErrorAcc = true
      }
    }
  },
  components: {
    customerDetail
  },
  props: ['auth', 'authenticated', 'cust']
}
</script>

<style>
.error {
  color: red;
  padding-top: 5px;
}
</style>
